module.exports = __webpack_public_path__ + "img/1497155313.14b2bffc.jpg";